import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Menu, SIZE } from '@quinyx/ui';

import { useTranslate } from '../../hooks/translate';

interface ISubMenuLink {
  id: string;
  route: string;
  linkLabel: string;
  hidden?: boolean;
}

export interface ISubMenu {
  title: string;
  key: string;
  links: ISubMenuLink[];
  hidden?: boolean;
}

interface ISideMenu {
  menuTree: ISubMenu[];
}

const SideMenu: FC<ISideMenu> = ({ menuTree }) => {
  const { t } = useTranslate();
  const location = useLocation();
  const section = location.pathname.split('/')[1];

  return (
    <Box p={SIZE.M}>
      <Menu
        data-test-id={`side-menu-${section}`}
        aria-label={t('sideMenu.label', { section })}>
        {menuTree.map(({ title, links, hidden: hiddenMenu }, i) => {
          if (hiddenMenu) return null;
          return (
            <React.Fragment key={title}>
              <Menu.Label text={title} />
              {links.map(({ id, route, linkLabel, hidden }) => {
                if (hidden) return null;
                const isActive = route === location.pathname;

                return (
                  <Link
                    key={id}
                    data-test-id={`side-menu-item-${id}-link`}
                    to={route}
                    tabIndex={-1}>
                    <Menu.Item
                      data-test-id={`side-menu-item-${id}`}
                      selected={isActive}>
                      {linkLabel}
                    </Menu.Item>
                  </Link>
                );
              })}
              {i < menuTree.length - 1 && <Menu.Separator />}
            </React.Fragment>
          );
        })}
      </Menu>
    </Box>
  );
};

export default SideMenu;
